import React, { useRef } from "react"
import { IconCirclePlusOutline18 as AttachIcon } from "nucleo-ui-outline-18"
import { z } from "zod"

import { EmailAttachmentSchema } from "@productlane/api/src/browser"
import { VALID_FILE_TYPES } from "@productlane/api/src/lib/files"
import { IconButton, Tooltip } from "@productlane/ui"

export const AttachmentsSchema = z.array(EmailAttachmentSchema)

const DEFAULT_ACCEPT = VALID_FILE_TYPES.map((type) => `.${type}`).join(",")

export const FileUpload = ({
	addFiles,
}: {
	addFiles: (files: File[] | FileList) => Promise<void>
}) => {
	const fileInputRef = useRef<HTMLInputElement>(null)

	const initUpload = () => {
		fileInputRef.current?.click()
	}

	const handleFileInputChange = async (
		event: React.ChangeEvent<HTMLInputElement>,
	) => {
		const files = event.target.files
		if (!files) {
			return
		}
		await addFiles(files)

		event.target.value = ""
	}

	return (
		<Tooltip label="Attach images, files or videos">
			{/* empty div to make tooltip works */}
			<div>
				<input
					type="file"
					multiple
					onChange={handleFileInputChange}
					ref={fileInputRef}
					className="hidden"
					accept={DEFAULT_ACCEPT}
				/>
				<IconButton
					Icon={AttachIcon}
					variant="ghost"
					className="h-[1.625rem] w-[1.625rem] cursor-default text-secondary hover:text-primary"
					iconClassName="h-4 w-4"
					iconStrokeWidth={1.25}
					onClick={initUpload}
				/>
			</div>
		</Tooltip>
	)
}
